document.addEventListener('DOMContentLoaded', () => {
  function initialiseProducts(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialised) return;
      section.dataset.initialised = 'true';
      const select = section.querySelector('[data-variant-select]');
      const variants = JSON.parse(section.querySelector('[data-variants]').textContent);
      const button = section.querySelector('[data-add-button]');
      const quantity = section.querySelector('[data-product-quantity]');

      const form = section.querySelector('form[action*="/cart/add"]');
      const notice = section.querySelector('[data-basket-notice]');
      const message = section.querySelector('[data-basket-message]');
      const error = section.querySelector('[data-basket-error]');
      const live = section.querySelector('[data-basket-live]');
      if (form && notice) {
        let adding = false;
        const closeNotice = () => {
          const returnFocus = notice.contains(document.activeElement);
          notice.hidden = true;
          if (returnFocus) button.focus();
        };
        notice.querySelectorAll('[data-close-basket-notice]').forEach(close => close.addEventListener('click', closeNotice));
        section.addEventListener('keydown', event => {
          if (event.key === 'Escape' && !notice.hidden) closeNotice();
        });
        form.addEventListener('submit', async event => {
          event.preventDefault();
          if (adding || button.disabled || !form.reportValidity()) return;
          adding = true;
          notice.hidden = true;
          error.hidden = true;
          live.textContent = '';
          const originalButton = button.innerHTML;
          const data = new FormData(form);
          const addedQuantity = Number(data.get('quantity')) || 1;
          const rootUrl = window.Shopify?.routes?.root || '/';
          data.delete('return_to');
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          button.textContent = section.dataset.addingLabel;
          try {
            const response = await fetch(rootUrl + 'cart/add.js', {
              method: 'POST',
              body: data,
              headers: { Accept: 'application/json' }
            });
            const result = await response.json();
            if (!response.ok || result.status >= 400) {
              const failure = new Error(section.dataset.errorLabel);
              failure.customerMessage = typeof result.description === 'string' ? result.description : section.dataset.errorLabel;
              throw failure;
            }
            const item = result.items?.[0] || result;
            const productName = item.product_title || section.dataset.productTitle;
            const option = item.variant_title && item.variant_title !== 'Default Title' ? ' · ' + item.variant_title : '';
            message.textContent = addedQuantity + ' × ' + productName + option;
            document.querySelectorAll('.basket-count').forEach(count => {
              count.textContent = String((Number(count.textContent) || 0) + addedQuantity);
            });
            notice.hidden = false;
            live.textContent = section.dataset.addedLabel + ': ' + message.textContent;
            try {
              const cartResponse = await fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
              if (cartResponse.ok) {
                const cart = await cartResponse.json();
                document.querySelectorAll('.basket-count').forEach(count => { count.textContent = String(cart.item_count); });
              }
            } catch {}
          } catch (failure) {
            error.textContent = failure.customerMessage || section.dataset.errorLabel;
            error.hidden = false;
          } finally {
            adding = false;
            button.removeAttribute('aria-busy');
            const currentVariant = variants.find(v => String(v.id) === select.value);
            button.disabled = !currentVariant?.available || !currentVariant?.priced;
            button.innerHTML = originalButton;
            if (currentVariant && String(data.get('id')) !== select.value) {
              button.textContent = !currentVariant.priced ? button.dataset.labelUnpriced : currentVariant.available ? button.dataset.labelAdd : button.dataset.labelSold;
            }
          }
        });
      }

      select.addEventListener('change', () => {
        const variant = variants.find(v => String(v.id) === select.value);
        if (!variant) return;
        section.querySelector('[data-price]').textContent = variant.price;
        section.querySelector('[data-unit-price]').textContent = variant.unitPrice;
        button.disabled = !variant.available || !variant.priced;
        button.textContent = !variant.priced ? button.dataset.labelUnpriced : variant.available ? button.dataset.labelAdd : button.dataset.labelSold;
        quantity.min = variant.minimum;
        quantity.step = variant.increment;
        if (variant.maximum) quantity.max = variant.maximum;
        else quantity.removeAttribute('max');
        const old = Number(quantity.value);
        let next = Math.max(variant.minimum, Math.ceil(old / variant.increment) * variant.increment);
        if (variant.maximum) next = Math.min(next, variant.maximum);
        quantity.value = next;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      });
    });
  }
  initialiseProducts();
  document.addEventListener('shopify:section:load', e => initialiseProducts(e.target));
  document.querySelectorAll('.mobile-menu a').forEach(link => link.addEventListener('click', () => {
    link.closest('details').removeAttribute('open');
  }));
});
